import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from '@deepguide-ai/ui/button'
import { ArrowLeft } from 'lucide-react'
import ProfileSettings from '@/pages/settings/profile'

export const Route = createFileRoute('/(protected)/auditor-center/profile')({
  component: () => (
    <div className='px-6 py-8'>
      <Button variant='ghost' size='sm' asChild className='mb-6'>
        <Link to='/auditor-center'>
          <ArrowLeft className='h-4 w-4' />
          Audits
        </Link>
      </Button>
      <ProfileSettings />
    </div>
  ),
})
